import { B2Button } from "@hdb/biome-2";
import * as _ from "lodash";
import { FC, createRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  validateZipOrTarFile,
  zipFileTypes,
} from "src/shared/helpers/validate-Files";
import * as yup from "yup";
import ModalComponent from "../../../../../core/components/modal/modal.component";
import TableComponent from "../../../../../core/components/table/table.component";
import HasPermission from "../../../../../core/guards/has-permission";
import FormBuilderComponent, {
  FormConfig,
} from "../../../../../shared/form-builder/form-builder.component";
import {
  addOta,
  deleteOta,
  editOta,
  getAssetModelBySLSSupplier,
  getDownloadOTAbyAssetModel,
  getOTA,
  getOTAById,
  getSLSSupplier,
  publishOta,
} from "../../../../../store/slices/ota.slice";
import SearchBarComponent from "../../search-bar/search-bar.component";
import "../dms.scss";
import OtaPublishComponent from "./ota-publish.component";
import { getUserInfo } from "src/core/auth/auth.service";
import { displayToast } from "src/shared/helpers/toaster.helper";
import "../../../admin.scss";

interface DOTATableComponentProps {
  columns: any;
  data: any[];
  totalNumberOfRecords: number;
  pageSize: number;
  current: number;
  onChangePage: any;
  onChangeSort: any;
  isLoadingOTA: any;
  onRefetchData: () => void;
  onSearch: (val: string) => void;
}

const OTATableComponent: FC<DOTATableComponentProps> = ({
  columns,
  data,
  totalNumberOfRecords,
  pageSize,
  current,
  onChangePage,
  onChangeSort,
  onRefetchData,
  isLoadingOTA,
  onSearch,
}) => {
  const formRef = createRef();
  const [preview, setPreview] = useState<any>("");
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isShowImage, setIsShowImage] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [selectedFile, setSelectedFile] = useState<File | null>();
  const [selectedIdToDeleteOrEdit, setSelectedIdToDeleteOrEdit] =
    useState<number>(0);
  const [isPublish, setIsPublish] = useState<boolean>(false);
  const [isDownload, setIsDownload] = useState<boolean>(false);
  const [supplierOptions, setSupplierOptions] = useState<any>([]);
  // const [assetModelOptions, setAssetModelOptions] = useState<any>([]);
  const [isOTAPublishModalOpen, setIsOTAPublishModalOpen] = useState(false);
  const [isAWSLink, setIsAWSLink] = useState(false);
  const user = getUserInfo();

  const [initialValues, setInitialValues] = useState<any>({
    OTAUploadFile: "",
    AssetModel: "",
    checksum: "",
    SupplierId: "",
    FirmwareVersion: "",
    Description: "",
  });
  const [uploadFileName, setUploadFileName] = useState<string>("");
  const [isDisabledCheckSum, setIsDisabledCheckSum] = useState(false);

  const dispatch = useDispatch();

  const otaDetails = useSelector((state: any) => {
    return state.ota.otaDetails;
  });

  useEffect(() => {
    dispatch(getSLSSupplier());
  }, []);

  const suppliersData = useSelector((state: any) => {
    return state.ota.slsSupplier;
  });

  useEffect(() => {
    const sls = suppliersData?.data?.map((sl: any) => ({
      label: sl?.name,
      value: sl?.id,
    }));

    setSupplierOptions(sls);
  }, [suppliersData]);

  const onSelectSupplier = (selectedSupplier: any) => {
    // setAssetModelOptions([]);
    dispatch(getAssetModelBySLSSupplier({ supplierId: selectedSupplier }));
  };

  // const assetModelData = useSelector((state: any) => {
  //   return state.ota.assetModelBySLSSupplier;
  // });

  // useEffect(() => {
  //   const assetModel = assetModelData?.data?.map((am: any) => ({
  //     label: am?.assetModel,
  //     value: am?.assetModel,
  //   }));

  //   // setAssetModelOptions(assetModel);
  // }, [assetModelData]);

  const socketRealTimeUpdate = useSelector((state: any) => {
    return state.asset.socketRealTimeUpdate;
  });

  const socketRealTimeUpdateData = useSelector((state: any) => {
    return state.asset.socketRealTimeUpdateData;
  });

  const socketData = useSelector((state: any) => {
    return state.asset.socketData;
  });

  useEffect(() => {
    const copiedSocketRealTimeUpdate = _.cloneDeep(socketRealTimeUpdate);

    if (copiedSocketRealTimeUpdate?.FirmwareVersion) {
      onRefetchData();
      showToaster(socketRealTimeUpdateData);
    }
  }, [socketRealTimeUpdate]); // socketRealTimeUpdateData

  const showToaster = (socketRealTimeUpdateData: any) => {
    if (
      user[
      "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
      ] === socketData?.NotificationIdentifier
    ) {
      displayToast(
        socketRealTimeUpdateData?.PushMessage || "Acknowledgement Received",
        socketRealTimeUpdateData?.ToasterColor,
      );
    }
  };

  const handleCloseModal = () => {
    setIsShowImage(false);
    setIsModalOpen(false);
    setIsEdit(false);
    setIsDelete(false);
    setIsPublish(false);
    setIsDownload(false);
    setSelectedFile(null);

    setInitialValues({
      OTAUploadFile: "",
      checksum: "",
      AssetModel: "",
      SupplierId: "",
      FirmwareVersion: "",
      Description: "",
    });
  };

  const editAction = (id: number) => {
    setIsShowImage(true);

    dispatch(getOTAById({ Id: id }))
      .then((data: any) => {
        setIsEdit(true);
        setIsModalOpen(true);
        setIsDelete(false);
        setIsPublish(false);

        setIsDownload(false);
        setPreview(data.payload.uploadedFileAWSURL);
        setIsAWSLink(true);
        setUploadFileName(data.payload.uploadedFileName);

        dispatch(
          getAssetModelBySLSSupplier({ supplierId: data?.payload?.supplierId }),
        );
      })
      .catch((error: any) => {
        console.log("Error in getOTAById api call: ", error);
      });

    setSelectedIdToDeleteOrEdit(id);
  };

  const publishAction = (id: number) => {
    setIsDownload(false);
    setIsEdit(false);
    setIsDelete(false);
    setIsOTAPublishModalOpen(true);

    setSelectedIdToDeleteOrEdit(id);
    // console.log("the publish action: ", id);
  };

  const downloadAction = (id: any) => {
    setIsDownload(true);
    setIsPublish(false);
    setIsEdit(false);
    setIsDelete(false);

    dispatch(getDownloadOTAbyAssetModel({ Id: id }));
  };

  const handlePublish = () => {
    // console.log(`Id ${selectedIdToDeleteOrEdit} is selected to publish`);

    // console.log("publish", selectedIdToDeleteOrEdit, data);

    dispatch(getOTAById({ Id: selectedIdToDeleteOrEdit })).catch(
      (error: any) => {
        console.log("Error in getOTAById api call: ", error);
      },
    );

    if (!otaDetails || !Object.keys(otaDetails).length) return;

    const payload = {
      assetModel: otaDetails.assetModel,
      supplierId: otaDetails.supplierId,
      firmwareVersion: otaDetails.firmwareVersion,
    };

    /* call an api here to delete the selected id */
    dispatch(publishOta({ payload })).then(() => {
      onRefetchData();
      handleCloseModal();
    });
  };

  const deleteAction = (id: number) => {
    setIsPublish(false);
    setIsDownload(false);
    setIsModalOpen(true);
    setIsEdit(false);
    setIsDelete(true);
    setIsOTAPublishModalOpen(false);

    setSelectedIdToDeleteOrEdit(id);
    // console.log("the delete action: ", id);
  };

  const handleDelete = () => {
    /* call an api here to delete the selected id */
    dispatch(deleteOta({ id: selectedIdToDeleteOrEdit })).then(() => {
      onRefetchData();
      handleCloseModal();
    });
  };

  useEffect(() => {
    if (!otaDetails || !Object.keys(otaDetails).length) return;

    setInitialValues({
      OTAUploadFile: otaDetails?.otaUploadLoaction || "",
      checksum: otaDetails?.checksum || "",
      AssetModel: otaDetails?.assetModel || "",
      SupplierId: otaDetails?.supplierId || "",
      FirmwareVersion: otaDetails?.firmwareVersion || "",
      Description: otaDetails?.description || "",
    });

    const url = otaDetails?.uploadedFileAWSURL;
    const fileName = otaDetails?.uploadedFileName;

    //  setFile(downloadedFile);
    setPreview(url);
    setIsAWSLink(true);
    setUploadFileName(fileName);
    setIsDisabledCheckSum(true);
  }, [otaDetails]);

  // useEffect(() => {
  //   const fetchFile = async () => {
  //     if (!preview.length && !uploadFileName.length) return;
  //     const downloadedFile = await awslinkToFileConversion(
  //       preview,
  //       uploadFileName
  //     );
  //     // setSelectedFile(downloadedFile);
  //   };

  //   fetchFile();
  // }, [preview, uploadFileName]);

  const onSubmit = () => {
    const form: any = formRef.current;

    const {
      // AssetModel,
      Description,
      FirmwareVersion,
      // OTAUploadFile,
      checksum,
      SupplierId,
    } = form.values;

    if (form) {
      form.handleSubmit();
      if (
        !FirmwareVersion ||
        !SupplierId ||
        !checksum ||
        // OTAUploadFile === "" ||
        FirmwareVersion?.length > 50 ||
        checksum?.length > 100 ||
        Description?.length > 200
      )
        return;

      if (isEdit) {
        const formValues = form.values;
        const payload = {
          ...formValues,
          currentAWSLink: preview,
          id: selectedIdToDeleteOrEdit,
        };

        dispatch(
          editOta({
            payload,
            id: selectedIdToDeleteOrEdit,
            file: selectedFile || null,
          }),
        )
          .then((res: any) => {
            // console.log(res);
            if (res.payload.status !== 400) {
              handleCloseModal();
              onRefetchData();
            }
          })
          .catch((err: any) => { });
      } else {
        dispatch(addOta({ payload: form.values, file: selectedFile || null }))
          .then((response: any) => {
            if (response.payload.status !== 400) {
              handleCloseModal();
              onRefetchData();
            }
          })
          .catch((err: any) => {});
      }
    }
    // return;
    // handleCloseModal();
  };

  const getOtaModalActionConfig = (): any => {
    if (isPublish) {
      return [
        { 
          label: "Publish", 
          event: handlePublish, 
          variant: "success", 
        }
      ];
    }
    if (isDelete) {
      return [
        { 
          label: "Yes", 
          event: handleDelete, 
          variant: "primary", 
        }
      ];
    }
    return [
      { 
        label: "Save", 
        event: onSubmit, 
        variant: "primary", 
      }
    ];
  };

  const modalActionConfig = getOtaModalActionConfig();

  const actionConfig: any = [
    {
      label: "Edit",
      actionProperty: "id",
      event: editAction,
      variant: "secondary",
      className: "mx-2 my-1",
      moduleName: "OTA",
      actionName: "Edit-OTA",
    },
    {
      label: "Publish",
      actionProperty: "id",
      event: publishAction,
      variant: "info",
      className: "mx-2 my-1",
      moduleName: "OTA",
      actionName: "Publish-OTA",
    },
    {
      label: "Download",
      actionProperty: "id",
      event: downloadAction,
      variant: "info",
      className: "mx-2 my-1",
    },
    {
      label: "Delete",
      actionProperty: "id",
      event: deleteAction,
      variant: "danger",
      className: "mx-2 my-1",
      moduleName: "OTA",
      actionName: "Delete-OTA",
    },
  ];

  const emptyConfig = {
    title: "No OTA Found",
    description: "",
  };

  async function handleFile(event: React.ChangeEvent<HTMLInputElement>) {
    setIsShowImage(false);

    if (!event.target.files || event.target.files.length === 0) {
      setSelectedFile(undefined);
      return;
    }

    const isValid = await validateZipOrTarFile(event.target.files[0]);
    if (!isValid) {
      event.target.value = "";
      setSelectedFile(null);
      return;
    }

    setSelectedFile(event.target.files[0]);
  }

  useEffect(() => {
    if (!selectedFile) setPreview("");
  }, [selectedFile]);

  const formConfig: FormConfig = {
    controls: [
      {
        name: "OTAUploadFile",
        label: "Upload OTA",
        placeholder: "it should be a uploader",
        type: "file",
        onChange: handleFile,
        filterFileTypes: zipFileTypes,
        required: true,
        info: "Supported file types: zip, tar",
      },
      {
        name: "checksum",
        label: "Checksum ( SHA-256 )",
        placeholder: "SHA-256",
        type: "text",
        required: true,
        disabled: isDisabledCheckSum,
      },
      {
        name: "SupplierId",
        label: "Supplier",
        placeholder: "Select Supplier",
        type: "searchable-select",
        onChange: onSelectSupplier,
        options: supplierOptions,
        required: true,
      },
      {
        name: "FirmwareVersion",
        label: "Firmware Version",
        placeholder: "1.0",
        type: "text",
        required: true,
      },
      {
        name: "Description",
        label: "Description",
        placeholder: "Something...",
        type: "textarea",
      },
    ],
  };

  const validationSchema = yup.object().shape({
    OTAUploadFile: yup.string().required("OTA is required"),
    // AssetModel: yup.string().required("Asset Model is required"),
    SupplierId: yup.string().required("Supplier is required"),
    FirmwareVersion: yup
      .string()
      .required("Firmware Version is required")
      .max(50, "Firmware Version must be at most 50 characters"),
    checksum: yup
      .string()
      .required("Checksum is required")
      .max(100, "Checksum must be at most 100 characters"),
    Description: yup
      .string()
      .max(200, "Description should not exceed 200 characters"),
  });

  const [isUpdated, setIsUpdated] = useState(0);

  const onRemoveFile = () => {
    setSelectedFile(undefined);
    setPreview("");
    setIsAWSLink(false);

    const form: any = formRef.current;
    const {
      AssetModel,
      Description,
      FirmwareVersion,
      OTAUploadFile,
      // checksum,
      SupplierId,
    } = form.values;

    setInitialValues({
      OTAUploadFile: OTAUploadFile || null,
      checksum: "",
      AssetModel: AssetModel || "",
      SupplierId: SupplierId || "",
      FirmwareVersion: FirmwareVersion || "",
      Description: Description || "",
    });
    setIsDisabledCheckSum(false);
    setIsShowImage(false);
    setIsUpdated(isUpdated + 1);
  };

  const otaPublishStates = {
    isOTAPublishModalOpen,
    setIsOTAPublishModalOpen,
    selectedIdToDeleteOrEdit,
    onRefetchData,
    data,
  };

  const getOtaModalHeaderTitle = () => {
    if (isEdit) return "Edit OTA";
    if (isDelete) return "Delete OTA";
    if (isDownload) return "Download OTA";
    return "Add OTA";
  };

  return (
    <div>
      <div>
        <div className="my-3">
          <div className="d-flex gap-3 justify-content-end table-generic-action mb-3 table-toolbar">
            <SearchBarComponent
              placeholder="Search OTA"
              methodToDispatch={getOTA}
              getSearch={onSearch}
            />
            <HasPermission
              moduleName="OTA"
              actionName="Add-OTA"
              isRoute={false}
            >
              <B2Button
                className="icon-text-btn"
                variant="primary"
                onClick={() => {
                  setIsModalOpen(true);
                  setIsDisabledCheckSum(false);
                }}
              >
                Upload OTA
              </B2Button>
            </HasPermission>
          </div>
          <TableComponent
            tableHeaders={columns}
            emptyConfig={emptyConfig}
            actionConfig={actionConfig}
            data={data}
            totalNumberOfRecords={totalNumberOfRecords}
            pageSize={pageSize}
            current={current}
            onChangePage={onChangePage}
            onChangeSort={onChangeSort}
            isLoadingData={isLoadingOTA}
          />
        </div>
      </div>

      {/* modals */}

      {isModalOpen && (
        <ModalComponent
          isConformationModal={isDelete}
          showModal={isModalOpen}
          handleClose={handleCloseModal}
          headerTitle={getOtaModalHeaderTitle()}
          size={isDelete || isPublish ? "sm" : "lg"}
          actionConfig={modalActionConfig}
        >
          {isDelete ? (
            <h5 className="text-center">
              Are you sure to <b className="text-danger">Delete</b>?
            </h5>
          ) : (
            <FormBuilderComponent
              key={isUpdated}
              formRef={formRef}
              initialValues={initialValues}
              validation={validationSchema}
              formConfig={formConfig}
              fileConfig={{
                fileName: uploadFileName,
                isShowImage,
                isEdit,
                onRemoveFile: onRemoveFile,
                preview,
                isLink: isAWSLink,
              }}
            />
          )}
        </ModalComponent>
      )}

      {isOTAPublishModalOpen && (
        <OtaPublishComponent otaPublishStates={otaPublishStates} />
      )}
    </div>
  );
};

export default OTATableComponent;
